// extracted by mini-css-extract-plugin
export var attachment = "_qs-a";
export var emailContainer = "_qs-4";
export var emailContentPaddedContainer = "_qs-b";
export var emailHeader = "_qs-6";
export var emailIframe = "_qs-3";
export var emailInfoIcon = "_qs-9";
export var emailShortenedSummary = "_qs-e";
export var infoDropdown = "_qs-0";
export var infoRowBoundedContent = "_qs-d";
export var internal = "_qs-5";
export var merchant = "_qs-8";
export var messageInputContainer = "_qs-h";
export var normal = "_qs-7";
export var replyCard = "_qs-f";
export var subtleButton = "_qs-1";
export var subtleButtonIconContainer = "_qs-2";
export var toggleViewRepliesButton = "_qs-c";
export var wrappingText = "_qs-g";